module.exports = __webpack_public_path__ + "img/lPut.45ebbc08.svg";